export const emailfieldName = "email";
export const passwordfieldName = "password";
export const firstfieldName = "first_name";
export const lastfieldName = "last_name";
export const phonefieldName = "phone_number";

